import AllInOne from '../components/AllInOne';
import BulkBanner from '../components/BulkBanner';
import BuyStrip from '../components/BuyStrip';
import CommonErrors from '../components/CommonErrors';
import Consultation from '../components/Consultation';
import Hero from '../components/Hero';
import MidCta from '../components/MidCta';
import Products from '../components/Products';
import Steps from '../components/Steps';
import StuckCta from '../components/StuckCta';
import WhyChoose from '../components/WhyChoose';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <CommonErrors />
      <Steps />
      <MidCta />
      <WhyChoose />
      <Products />
      <BulkBanner />
      <BuyStrip />
      <AllInOne />
      <Consultation />
      <StuckCta />
    </main>
  );
}
